import { Col, Row } from "antd";
import moment from "moment";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";

export const ReturnFilter = ({ setSubmit, submit }) => {
  return (
    <div className="bg-white mb-10 px-5 py-8 radius-bottom" id="ant_inputs">
      <Row gutter={[12, 12]}>
        <Col className="gutter-row" xs={24} lg={6}>
          <ContentInputField
            name={"Return ID"}
            placeholder={"Return Id"}
            value={submit?.returnId}
            onChange={(e) => {
              setSubmit({
                ...submit,
                returnId: e.target.value,
              });
            }}
          />
        </Col>
        <Col className="gutter-row" xs={24} lg={6}>
          <ContentInputField
            name={"Order ID"}
            placeholder={"Order Id"}
            value={submit?.orderId}
            onChange={(e) => {
              setSubmit({
                ...submit,
                orderId: e.target.value,
              });
            }}
          />
        </Col>
        <Col className="gutter-row" xs={24} lg={6}>
          <ContentInputField
            name={"Transaction ID"}
            placeholder={"Transaction Id"}
            value={submit?.transactionID}
            onChange={(e) => {
              setSubmit({
                ...submit,
                transactionID: e.target.value,
              });
            }}
          />
        </Col>

        <Col className="gutter-row" xs={24} lg={6}>
          <ContentInputField
            name={"Customer"}
            placeholder={"Customer"}
            value={submit?.customerName}
            onChange={(e) => {
              setSubmit({
                ...submit,
                customerName: e.target.value,
              });
            }}
          />
        </Col>

        <Col className="gutter-row" xs={24} lg={6}>
          <AllRangePicker
            name={"Order Date"}
            value={[
              submit?.fromDate && moment(submit?.fromDate, "DD/MM/YYYY"),
              submit?.toDate && moment(submit?.toDate, "DD/MM/YYYY"),
            ]}
            disabledDate={(current) => {
              return moment().add(0, "days") <= current;
            }}
            onChange={(value, dateString) => {
              value &&
                setSubmit({
                  ...submit,
                  fromDate: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                  toDate: moment(value[1]["$d"]).format("DD/MM/YYYY"),
                });
            }}
          />
        </Col>

        <Col className="gutter-row" xs={24} lg={18}>
          <p className="font-weight-bolder font-size-sm mb-2">&nbsp;</p>
          <button
            type="reset"
            className="all_bottom_buttons d-block ml-auto"
            onClick={() => {
              setSubmit({
                ...submit,
                paginationFilter: {
                  offset: 0,
                  limit: 10,
                  order: "DESC",
                },
                returnId: "",
                orderId: "",
                transactionId: "",
                customerName: "",
                toDate: "",
                fromDate: "",
              });
            }}
          >
            Reset
          </button>
        </Col>
      </Row>
    </div>
  );
};
